
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FieldItemProps } from ".";
import { loading, fieldUpdate } from "store/form";
import { AppMessage } from "components";

interface ApiFieldUpdateInputProps extends FieldItemProps {
}

type ApiFieldUpdateOutputProps = OutputBaseProps<{ item: FieldItemProps; }, ApiFieldUpdateInputProps>

export const apiFieldUpdate = async (data: ApiFieldUpdateInputProps, formId: number) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiFieldUpdateOutputProps>(`/api/form/${formId}/field/update`, data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(fieldUpdate({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};